export default __webpack_public_path__ + "locales/el-GR/ChangeEmailDialog.json?hash=8d4b43e6346a8f46870257fa8d2556d8";